<template>
  <div>
    <bot-migration ref="botMigrator" />
    <h1>Bots Versions</h1>
    <v-dialog v-model="exportSuccessDialog" width="500">
      <v-card class="card-curvey" v-if="exportResult">
        
        <v-divider />
        <v-card-actions>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="exportNewVersionDialog" width="500">
      <v-card>
        <v-card-title>
          <h3>Export New Version</h3>
        </v-card-title>
        <v-card-text v-if="!tempVersion">
          <label>Version Name</label>
          <v-text-field
            v-model="input.version"
            :loading="loader.exportNew"
            placeholder="Version Name.."
            outline
          />
          <label>Description</label>
          <v-textarea
            v-model="input.description"
            :loading="loader.exportNew"
            placeholder="Version Description.."
            outline
          />
          <label>Search Word</label>
          <v-text-field
            v-model="input.search_word"
            :loading="loader.exportNew"
            placeholder="Version Name.."
            outline
          />
          <label>Replace Word</label>
          <v-text-field
            v-model="input.replace_word"
            :loading="loader.exportNew"
            placeholder="Version Name.."
            outline
          />
        </v-card-text>

        <v-card-text v-else>
          <b>
          Exported Successfully, Copy the following url and import it, or quick
          import from here.
        </b>
        <v-chip
          v-if="tempVersion && exportResult"
          v-clipboard:copy="exportResult.url"
          v-clipboard:success="onCopyVersionUrl"
          class="cursor-pointer"
          close
          @input="handleChipClose"
        >
          <span class="url-chip-label">Copy Exported URL</span>
          <v-icon small class="pl-2">file_copy</v-icon>
        </v-chip>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="error"
            flat
            @click="exportNewVersionDialog = false">
            Close
          </v-btn>
          <v-spacer />
          <v-btn v-if="tempVersion" color="primary" outline @click="tempVersion = null">Export Another Version</v-btn>
          <v-btn v-if="tempVersion" color="primary" @click="quickImport(exportResult)">Quick Import</v-btn>
          <v-btn
            v-if="!tempVersion"
            color="primary"
            :loading="loader.exportNew"
            :disabled="!input.version.length"
            style="width: 200px"
            @click="exportNew">
            Export
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-card class="card-curvey">
      <v-layout row wrap>
        <v-text-field
              v-model = "search"
              placeholder = "Search"
              append-icon = "search"
              outline />
        <v-spacer />
        <v-chip
          v-if="exportResult"
          v-clipboard:copy="exportResult.url"
          v-clipboard:success="onCopyVersionUrl"
          class="cursor-pointer"
          close
          @input="handleChipClose"
        >
          <span class="url-chip-label">Copy Exported URL</span>
          <v-icon small class="pl-2">file_copy</v-icon>
        </v-chip>
        <v-btn class="nlp-nav-btn" color = "blue-grey" outline small @click="toggleExportNewDialog(true)">
        <v-icon>add</v-icon>
        Export New
      </v-btn>
        <v-btn outline class="nlp-nav-btn" color="blue-grey" small @click="importBot">
        <v-icon>arrow_downward</v-icon>
        Import Bot
      </v-btn>
    </v-layout>
      <v-data-table
        :headers="headers"
        :items="filterdVersions"
        item-key="index"
        no-data-text="No Versions Available"
        class="elevation-1 nlp-data-table"
      >
        <template slot="items" slot-scope="props">
          <tr>
            <td style="text-align: left">
              {{ props.item.version }}
            </td>
            <td style="text-align: left">
              {{ props.item.description }}
            </td>
            <td class="text-center">
              {{ $moment(props.item.exported_at).format('h:m A D/M/YYYY') }}
            </td>
            <td style="text-align: right">
              <v-chip
                v-clipboard:copy="props.item.url"
                v-clipboard:success="onCopyVersionUrl"
                class="cursor-pointer"
              >
                Copy URL
                <v-icon small class="pl-2">file_copy</v-icon>
              </v-chip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    @click="quickImport(props.item)"
                    style="width: 70px !important; min-width: 70px !important"
                  >
                    <v-icon>arrow_downward</v-icon>
                  </v-btn>
                </template>
                <span>Import</span>
              </v-tooltip>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import botMigration from './../general-setings/chnnaelConfiguration/botMigration'
export default {
  name: 'VersionsList',
  components: {
    botMigration
  },
  data() {
    return {
      exportNewVersionDialog: false,
      exportSuccessDialog: false,
      search: '',
      input: {
        version: '',
        description: '',
        search_word: '',
        replace_word: ''
      },
      tempVersion: null,
      loader: {
        exportNew: false,
        getVersions: false
      },
      exportResult: null,
      selected: [],
      versions: [],
      headers: [
        {
          text: 'Version',
          align: 'left',
          // sortable: true,
          value: 'version'
        },
        {
          text: 'Description',
          align: 'left',
          // sortable: true,
          value: 'description'
        },
        {
          text: 'Export Date',
          align: 'center',
          sortable: true,
          value: 'export_date'
        },
        {
          text: 'URL',
          align: 'right',
          // sortable: true,
          value: 'url'
        }
      ]
    }
  },
  mounted() {
    this.getVersions()
  },
  computed: {
    botId() {
      return this.$store.state.bot.botId
    },
    filterdVersions() {
      return this.versions.map(i => ({ ...i, dateFormated: this.$moment(i.exported_at).format('h:m A D/M/YYYY') })).filter(
        (val) => this.isMatchingSearch(val)
      )
    }
  },
  watch: {
    exportNewVersionDialog(val) {
      if(!val) {
        this.tempVersion = null
      }
    }
  },
  methods: {
    getVersions() {
      this.$store.dispatch('setLoader', true)
      this.$http
        .get(`/bot/${this.botId}/export_versions`)
        .then((res) => {
          this.versions = res.data.versions.map((r, index) => ({ ...r, index }))
          this.$store.dispatch('setLoader', false)
        })
        .catch((err) => {
          this.$store.dispatch('setLoader', false)
          this.$store.dispatch('setSnackbar', {
            text: `Something went wrong`,
            color: 'error',
            status: true
          })
        })
    },
    onCopy(append = 'Text') {
      this.$store.dispatch('setSnackbar', {
        text: `${append} copied to your clipboard`,
        color: 'primary',
        status: true
      })
    },
    onCopyVersionName() {
      this.$store.dispatch('setSnackbar', {
        text: `Version name copied to your clipboard`,
        color: 'primary',
        status: true
      })
    },
    onCopyVersionUrl() {
      this.$store.dispatch('setSnackbar', {
        text: `Version URL copied to your clipboard`,
        color: 'primary',
        status: true
      })
    },
    exportVersion(payload, quickImport = false) {
      this.loader.exportNew = true
      this.$http({
        url: `/bot/${this.botId}/export`,
        method: 'post',
        data: payload
      })
        .then((res) => {
          this.exportResult = res.data
          this.loader.exportNew = false
          if (quickImport) {
            this.tempVersion = this.$_.cloneDeep(this.exportResult)
            this.$store.dispatch('setSnackbar', {
              text: `Exported Successfully`,
              color: 'success',
              status: true
            })
            this.input = {
              version: '',
              description: ''
            }
          }
          this.getVersions()
        })
        .catch((err) => {
          this.loader.exportNew = false
          this.$store.dispatch('setSnackbar', {
            text: `Something went wrong`,
            color: 'error',
            status: true
          })
        })
    },
    exportNew() {
      if (this.input.version && this.input.version.length) {
        this.exportVersion(this.input, true)
      } else {
        this.$store.dispatch('setSnackbar', {
          text: `Version Name is required`,
          color: 'error'
        })
        return
      }
    },
    toggleExportSuccessDialog() {
      this.exportSuccessDialog = true
    },
    importBot() {
      this.$refs.botMigrator.importDialog = true
    },
    handleChipClose(e) {
      if (!e) this.exportResult = null
    },
    quickImport(item) {
      this.exportNewVersionDialog = false
      this.$refs.botMigrator.importData.url = item.url
      this.importBot()
    },
    toggleExportNewDialog(status = true) {
      this.exportNewVersionDialog = true
    },
    isMatchingSearch(val) {
      return Object.keys(
        this.$_.pickBy(val, (item) => {
          if (
            typeof item !== 'object' &&
            `${item}`.toLowerCase().includes(this.search.toLowerCase())
          ) {
            return true
          } else if (typeof item === 'object')
            return this.isMatchingSearch(item)
        })
      ).length
    },
  }
}
</script>

<style lang="scss">
@import '@/assets/sass/commponents/nlp.scss';
.toolbar-appended-input {
  min-width: 350px;
  padding: 0 !important;
  .v-input__control .v-input__slot {
    padding: 0 !important;
    justify-content: center;
    display: flex;
    align-items: center;
    min-height: unset !important;
    margin-top: 0;
    height: auto;
    .v-input__append-inner {
      padding: 0 0 0 0 !important;
    }
    .v-text-field__slot {
      padding-left: 12px;
    }
  }
}
.url-chip-label {
  max-width: 200px;
  max-width: 200px;
  text-overflow: ellipsis;
  overflow: hidden;
  font-weight: bold;
}
</style>
